var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconly3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4587 4.71321C11.476 4.50597 12.524 4.50597 13.5413 4.71321C16.947 5.40696 19.5666 8.08688 20.2726 11.4523C19.8627 11.2485 19.4016 11.134 18.9141 11.134C18.5532 11.134 18.1939 11.1845 17.8466 11.2841L17.578 11.3611C16.0326 11.804 14.8649 13.0899 14.5584 14.6863C14.3833 15.5982 14.3833 16.5358 14.5584 17.4477C14.8649 19.0442 16.0326 20.3301 17.578 20.773L17.8466 20.85C18.1939 20.9495 18.5532 21 18.9141 21C20.6184 21 22 19.6011 22 17.8754L22 12.9248L21.9757 12.566C21.6624 7.94133 18.3328 4.10026 13.8447 3.18603C12.6271 2.93799 11.3729 2.93799 10.1553 3.18603C5.66717 4.10026 2.33756 7.94133 2.0243 12.566L2 12.9248L2.00001 17.8754C2 19.6011 3.38158 21 5.08586 21C5.44684 21 5.80608 20.9495 6.15342 20.85L6.42199 20.773C7.96742 20.3301 9.13514 19.0442 9.44163 17.4477C9.6167 16.5358 9.6167 15.5982 9.44163 14.6863C9.13514 13.0899 7.96743 11.804 6.42199 11.3611L6.15342 11.2841C5.80609 11.1845 5.44684 11.134 5.08586 11.134C4.5984 11.134 4.13733 11.2485 3.72744 11.4523C4.4334 8.08687 7.05297 5.40696 10.4587 4.71321Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconly3);
export default __webpack_public_path__ + "static/media/Iconly3.c7b0f40a8d98e87ab2fcf123a0d7852b.svg";
export { ForwardRef as ReactComponent };